import React, { FunctionComponent } from 'react';
import { ScreenReaderText, Text } from '@mlc/web-ui-toolkit';
import { asPercentage } from '../../../../../common/formatter';
import { InvestmentStrategy } from '../../../../../../logic/domains/planProfile.domain';
import planProfileTestIds from '../../PlanProfile.elements';

const DefaultOption: FunctionComponent<{
	strategy: InvestmentStrategy;
	display: boolean;
}> = ({ strategy, display }) => (
	<>
		<Text
			margin={0}
			marginBottom={4}
			fontWeight="semibold"
			marginTop={6}
			el="h5"
		>
			Plan Default Investment Option
		</Text>
		<Text
			data-id={planProfileTestIds.planDefaultStrategyOption}
			margin={0}
			el="p"
			aria-hidden={!display}
		>
			{display ? strategy.name.concat(': ') : 'N/A'}
			{!display && <ScreenReaderText>Not applicable</ScreenReaderText>}
			{display && (
				<Text fontWeight="semibold">
					{asPercentage(strategy.percentage, false)}
				</Text>
			)}
		</Text>
	</>
);

export default DefaultOption;
